export const clarityId = 'ozgz7ptmu5';